import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../context/authStore';

function ProtectedRoute({ children, role }) {
  const { user, userDoc } = useAuthStore();

  if (!user) return <Navigate to="/login" replace />;
  if (role && userDoc?.role !== role) return <Navigate to="/dashboard" replace />;

  return children;
}

export default ProtectedRoute;
